import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import HistoryGroupList from './HistoryGroupList';
import { groupByDate } from '../../utils';
import { sectionStyles } from '../../styles/drawerStyles';

/**
 * 최근 히스토리 섹션 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @returns {JSX.Element} - 최근 히스토리 섹션
 */
const RecentHistorySection = ({
  history,
  selectedHistoryId,
  setSelectedHistoryId,
  setAnalyzedVideoId,
  setAnalyzedTitle,
  setAnalyzedUrl,
  setDrawerOpen,
  isDesktop,
  projectSubMenuRefs,
  historyMenuRefs,
  setHistoryMenuAnchor,
  setHistoryMenuIdx,
  projects,
  handleAddHistoryToProject,
  handleEditHistory,
  handleDeleteClick,
  menuOpenIdx,
  setMenuOpenIdx,
  setHistory
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="subtitle2" sx={sectionStyles.sectionTitle}>
        {t('drawer.recentHistory')}
      </Typography>
      <HistoryGroupList
        grouped={groupByDate(history.filter(h => !h.projectId && h.status === 'active'))}
        history={history}
        selectedHistoryId={selectedHistoryId}
        setSelectedHistoryId={setSelectedHistoryId}
        setAnalyzedVideoId={setAnalyzedVideoId}
        setAnalyzedTitle={setAnalyzedTitle}
        setAnalyzedUrl={setAnalyzedUrl}
        setDrawerOpen={setDrawerOpen}
        isDesktop={isDesktop}
        projectSubMenuRefs={projectSubMenuRefs}
        historyMenuRefs={historyMenuRefs}
        setHistoryMenuAnchor={setHistoryMenuAnchor}
        setHistoryMenuIdx={setHistoryMenuIdx}
        projects={projects}
        handleAddHistoryToProject={handleAddHistoryToProject}
        handleEditHistory={handleEditHistory}
        handleDeleteClick={handleDeleteClick}
        menuOpenIdx={menuOpenIdx}
        setMenuOpenIdx={setMenuOpenIdx}
        setHistory={setHistory}
      />
    </Box>
  );
};

export default RecentHistorySection; 